import { hot } from 'react-hot-loader/root';
import { lazy } from 'react';

const ShopgateWidgetsProductListWidget = lazy(() => import('@shopgate/engage/page/widgets/ProductList'))

const ShopgateWidgetsCategoryListWidget = lazy(() => import('@shopgate/engage/page/widgets/CategoryList'))

const ShopgateWidgetsProductSliderWidget = lazy(() => import('@shopgate/engage/page/widgets/ProductSlider'))

const ShopgateWidgetsHtmlWidget = lazy(() => import('@shopgate/engage/page/widgets/HTML'))

const ShopgateWidgetsVideoWidget = lazy(() => import('@shopgate/engage/page/widgets/Video'))

const ShopgateWidgetsHeadlineWidget = lazy(() => import('@shopgate/engage/page/widgets/Headline'))

const ShopgateWidgetsImageWidget = lazy(() => import('@shopgate/engage/page/widgets/Image'))

const ShopgateWidgetsImageRowWidget = lazy(() => import('@shopgate/engage/page/widgets/ImageRow'))

const ShopgateWidgetsImageSliderWidget = lazy(() => import('@shopgate/engage/page/widgets/ImageSlider'))

const ShopgateWidgetsRichTextWidget = lazy(() => import('@shopgate/engage/page/widgets/RichText'))

const ShopgateWidgetsHeroBannerWidget = lazy(() => import('@shopgate/engage/page/widgets/HeroBanner'))

const ShopgateWidgetsButtonWidget = lazy(() => import('@shopgate/engage/page/widgets/Button'))

const ShopgateWidgetsInternalPlaceholder = lazy(() => import('@shopgate/engage/page/widgets/Placeholder'))

export default {
  '@shopgate/widgets/productListWidget': hot(ShopgateWidgetsProductListWidget),
  '@shopgate/widgets/categoryListWidget': hot(ShopgateWidgetsCategoryListWidget),
  '@shopgate/widgets/productSliderWidget': hot(ShopgateWidgetsProductSliderWidget),
  '@shopgate/widgets/htmlWidget': hot(ShopgateWidgetsHtmlWidget),
  '@shopgate/widgets/videoWidget': hot(ShopgateWidgetsVideoWidget),
  '@shopgate/widgets/headlineWidget': hot(ShopgateWidgetsHeadlineWidget),
  '@shopgate/widgets/imageWidget': hot(ShopgateWidgetsImageWidget),
  '@shopgate/widgets/imageRowWidget': hot(ShopgateWidgetsImageRowWidget),
  '@shopgate/widgets/imageSliderWidget': hot(ShopgateWidgetsImageSliderWidget),
  '@shopgate/widgets/richTextWidget': hot(ShopgateWidgetsRichTextWidget),
  '@shopgate/widgets/heroBannerWidget': hot(ShopgateWidgetsHeroBannerWidget),
  '@shopgate/widgets/buttonWidget': hot(ShopgateWidgetsButtonWidget),
  '@shopgate/widgetsInternal/Placeholder': hot(ShopgateWidgetsInternalPlaceholder),
};
